import request from '@/utils/http'

/**
 * 新闻资讯相关接口
 */

/**
 * 获取分类列表
 * @returns {Promise}
 */
export function getCategoryListApi() {
  return request({
    url: '/admin-api/browser/category/list',
    method: 'get',
    params: {
      catType: 0
    }
  })
}

/**
 * 查询新闻列表
 * @param {String} categoryIdentification - 分类标识
 * @param {Number} pageNo - 页码
 * @param {Number} pageSize - 每页数量
 * @returns {Promise}
 */
export function getNewsListApi(categoryIdentification, pageNo = 1, pageSize = 6) {
  return request({
    url: `/admin-api/browser/article/category-identifier/${categoryIdentification}`,
    method: 'get',
    params: {
      pageNo,
      pageSize
    }
  })
}

/**
 * 获取新闻详情
 * @param {Number|String} id - 新闻ID
 * @returns {Promise}
 */
export function getNewsDetailApi(id) {
  return request({
    url: `/admin-api/browser/article/${id}`,
    method: 'get'
  })
}

/**
 * 获取推荐新闻列表
 * @param {Number} params - 数量
 * @returns {Promise}
 */
export function getRecommendNewsListApi(params) {
  return request({
    url: '/admin-api/browser/article/recommend',
    method: 'get',
    params
  })
}

/**
 * 获取最新新闻列表
 * @param {Number} params - 数量
 * @returns {Promise}
 */
export function getLatestNewsListApi(params) {
  return request({
    url: '/admin-api/browser/article/latest',
    method: 'get',
    params
  })
}

